<template>
  <v-app>
    <Header />
    <v-main class="main-container">
      <div class="sidenav" v-if="loggedIn" v-bind:style="getMenuWidth">
        <LeftMenu />
      </div>
      <div class="main" v-bind:style="getMarginLeft">
        <v-container fluid>
          <v-slide-y-transition mode="out-in">
            <router-view></router-view>
          </v-slide-y-transition>
        </v-container>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapGetter, mapActions } from "vuex";
import Header from "./components/Header";
import LeftMenu from "./components/LeftMenu";
import auth from "./api/auth-helper";

export default {
  name: "App",
  components: {
    Header,
    LeftMenu,
  },
  created() {
      const favicon = document.getElementById("favicon");      
      favicon.href = require('./assets/favicon.png')
  },
  destroyed() {},
  computed: {
    ...mapState({ IsLeftMenuCollapse: "IsLeftMenuCollapse" }),
    isLogin() {
      this.loggedIn = auth.loggedIn();
      return this.$route.name === "Login";
    },
    menuHeight() {
      return {
        height: `${this.height}px`,
      };
    },
    getMenuWidth() {
      return {
        width: `${this.width}px`,
      };
    },
    getMarginLeft() {
      return {
        "margin-left": `${this.width}px`,
      };
    },
  },
  mounted() {
    window.addEventListener("resize", () => {});
  },
  watch: {
    IsLeftMenuCollapse: function (val) {
      this.width = val ? 50 : 200;
    },
  },
  methods: {
    setMenuHeight(e) {
      //document.getElementById("leftMenu").style.height = document.documentElement.clientHeight - 25 + "px";
      this.height = document.documentElement.clientHeight - 25;
    },
  },
  data: () => ({
    loggedIn: auth.loggedIn(),
    leftMenuSize: "",
    height: document.documentElement.clientHeight,
    width: 200,
  }),
};
</script>

<style scoped>
.main-container {
  background-color: #eee !important;
  border-color: #eee !important;
  padding-top: 40px !important;
}
.container {
  padding-top: 40px !important;
}
.containt {
  padding-top: 20px !important;
}

.sidenav {
  height: 100%;
  width: 200px;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  overflow-x: hidden;
  padding-top: 40px;
  overflow-x: hidden;
  overflow-y: hidden;
}
::-webkit-scrollbar {
  display: none;
}
.main {
  margin-left: 200px;
  padding: 0px 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue